import { createContext } from "react";
import { ClientDefaultItem } from "../types";
import { ClientDefaultsAction } from "./clientDefaultsReducer";

export const InvoicesClientDefaultsPageContext = createContext<{
  items: ClientDefaultItem[];
  dispatchItemsReducer: (action: ClientDefaultsAction) => void;
  submitForm: () => void;
} | null>(null);
